import React from 'react';
import Link from '../common/TrackedLink';

const UrlSiteSearch = ({ url }) => {
	// console.log("UrlSiteSearch")
	// console.dir(url);
	return (
		<li className="results-list-item">
			<div>
				<h2>{url.title}</h2>

				<Link className="arrow-link" to={`${url.url}`}>View more</Link>
			</div>
		</li>
	);
};

export default UrlSiteSearch;


// WEBPACK FOOTER //
// ./src/pages/sitesearch/UrlSiteSearch.js